import { lazy } from "react";
// General Module
// Calendar view for tasks and future appointments

const GeneralCalendarPage = lazy(() => import("./pages/GeneralCalendarPage"));
export { GeneralCalendarPage };

export const generalRoutes = [
  { path: "/general", element: <GeneralCalendarPage /> },
];
